import { render, staticRenderFns } from "./PasswordValidationErrors.vue?vue&type=template&id=12024dd3&"
import script from "./PasswordValidationErrors.vue?vue&type=script&lang=js&"
export * from "./PasswordValidationErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports